import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "form"]
  static values = {
    activeCard: String,
    completionType: String,
  }

  static formByCompletionType = {
    decline: "decline",
    query: "query",
    alternative: "decline-ff-quote",
  }

  connect() {
    let formName = this.constructor.formByCompletionType[this.completionTypeValue]
    if (this.completionTypeValue === "complete") {
      formName = this.formTargets.some(f => f.dataset.formType === "accept-ff") ? "accept-ff" : "quote"
    }
    if (formName) this.openForm(formName)
  }

  openForm(type) {
    this.activeCardValue = type
    this.cardTargets.forEach(card => {
      const isActive = card.dataset.cardType === type
      card.dataset.active = isActive.toString()
      card.dataset.dimmed = (!isActive).toString()
    })
    this.formTargets.forEach(form => {
      form.classList.toggle("hidden", form.dataset.formType !== type)
    })
  }

  selectCard(event) {
    const type = event.params.cardType
    if (type === this.activeCardValue) return

    this.openForm(type)
  }

  cancelForm() {
    this.activeCardValue = ""
    this.cardTargets.forEach(card => {
      delete card.dataset.active
      delete card.dataset.dimmed
    })
    this.formTargets.forEach(form => form.classList.add("hidden"))
  }
}
